import NewPasswordPage from '@/pages/NewPasswordPage/NewPasswordPage.vue'

export default NewPasswordPage
